import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const getUploads = async (params) => {
  try {
    const res = await getRequest({ url: "uploads", query: params });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getRecentJournals = async (params) => {
  try {
    const res = await getRequest({
      url: "uploads/recentJournals",
      query: params,
    });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postUpload = async (payload) => {
  try {
    const res = await postRequest({ url: "uploads", payload: payload });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putUpload = async ({ id, payload }) => {
  try {
    const res = await putRequest({
      url: "uploads",
      payload: payload,
      query: { UPLOAD_ID: id },
    });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};
